import { useState } from 'react';
import { AiOutlinePrinter } from 'react-icons/ai';
import { FiFileText } from 'react-icons/fi';
import { useParams } from 'react-router';

import { DataTable, StyledButton } from '../../../../../components';
import { useRelatorioMovimento } from '../../../../../services/hooks/useRelatorioMovimento';
import { ITransactions } from '../../../../../services/hooks/useRelatorioPagamento';
import { PrintComponent } from '../../../../../services/PrintComponent';
import { AdminTitle } from '../../../components';
import { Container, FiltersContainer } from './styles';

const tableHead = [
  'Data',
  'Hora',
  'NSU',
  'Valor',
  'Parcelas',
  'Terminal',
  'Cartão',
  'Movimento',
  'Autorização',
  'Bandeira',
];

export const RelatorioMovimentacao = () => {
  const { id, pagamento: stringTransaction } = useParams();

  const transaction: ITransactions =
    stringTransaction && JSON.parse(stringTransaction);

  const { data, isLoading, isFetching, error } = useRelatorioMovimento(id);

  const [print, setPrint] = useState(false);

  return (
    <Container>
      <AdminTitle title="Relatório Movimentação" icon={<FiFileText />} />
      <h3>Consulte aqui suas movimentações</h3>

      <FiltersContainer>
        <StyledButton
          text="Imprimir"
          icon={<AiOutlinePrinter />}
          iconPosition="right"
          onClick={() => setPrint(true)}
          disabled={isLoading || isFetching}
        />
      </FiltersContainer>

      <PrintComponent onPrint={print} setOnPrint={setPrint}>
        <DataTable title="Detalhado" heads={tableHead} hasPagination={false}>
          {isLoading || isFetching ? (
            <tbody>
              <tr>
                <td colSpan={11}>Carregando...</td>
              </tr>
            </tbody>
          ) : error ? (
            <tbody>
              <tr>
                <td colSpan={11}>Falha ao obter dados</td>
              </tr>
            </tbody>
          ) : data?.length === 0 ? (
            <tbody>
              <tr>
                <td colSpan={11}>Não foram encontrados dados</td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              {data?.map((pagamento) => (
                <tr key={pagamento.codVenda + pagamento.nsuTransacao}>
                  <td>
                    {new Date(pagamento.dtHrTransacao)?.toLocaleDateString(
                      'pt-BR'
                    )}
                  </td>
                  <td>
                    {new Date(pagamento.dtHrTransacao).toLocaleTimeString(
                      'pt-BR',
                      {
                        hour: '2-digit',
                        minute: '2-digit',
                      }
                    )}
                  </td>
                  <td>{pagamento.nsuTransacao}</td>
                  <td>
                    {pagamento.vlParcela?.toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                      minimumFractionDigits: 2,
                    })}
                  </td>
                  <td
                    style={{ textTransform: 'none' }}
                  >{`${pagamento.numParcela} de ${pagamento.qtdParcela}`}</td>
                  <td>{pagamento.numSerieLeitor}</td>
                  <td>{`${pagamento.cartaoBIN.slice(
                    0,
                    4
                  )} ${pagamento.cartaoBIN.slice(4)}XX XXXX ${
                    pagamento.cartaoHolder
                  }`}</td>
                  <td>Confirmada</td>
                  <td>{pagamento.codAutTransacao}</td>
                  <td>{transaction?.produtoDescricao}</td>
                </tr>
              ))}
            </tbody>
          )}
        </DataTable>
      </PrintComponent>
    </Container>
  );
};
